export default "__VITE_ASSET__DhVO3_lU__"